import { FilteringCondition } from "./filtering-condition";
export enum FilteringLogic {
    And,
    Or
}

/**
 * Represents filtering expressions.
 */
export declare interface IFilteringExpression {
    fieldName: string;
    condition: (value: any, searchVal?: any, ignoreCase?: boolean) => boolean;
    searchVal?: any;
    ignoreCase?: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/data-operations/filtering-expression.interface.ts